// extracted by mini-css-extract-plugin
export default {"root":"PlasmicHeadingStatus_root__EHR7O","text":"PlasmicHeadingStatus_text__4oQNu"};